// Toast
import AppToast from 'general/components/AppToast';
import DataCommonListener from 'general/listeners/DataCommonListener';
import React, { lazy, Suspense } from 'react';
import 'react-toastify/dist/ReactToastify.css';
// router
import AppDialog from 'general/components/AppDialog';
import GuestRoute from 'general/components/AppRoutes/GuestRoute';
import PrivateRoute from 'general/components/AppRoutes/PrivateRoute';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import KTPageError01 from 'general/components/OtherKeenComponents/KTPageError01';
import AppRoute from 'general/constants/AppRoute';
import AppDialogCustom from 'general/components/AppDialogCustom';
import GuestPaymentRoute from 'general/components/AppRoutes/GuestPaymentRoute';
import PageLoader from 'general/components/PageLoader';
import DashboardRoute from 'general/components/AppRoutes/DashboardRoute';
import AdminDashboardRoute from 'general/components/AppRoutes/AdminDashboardRoute';
import { ChargeConstants } from 'features/Charge/chargeHelper';
import { AgencyConstants } from 'features/Agency/agencyHelper';

// Lazy load features - Code splitting để giảm bundle size
const ManagePaymentTransactions = lazy(() => import('features/ManagePaymentTransactions'));
const Auth = lazy(() => import('features/Auth'));
const ManageDealer = lazy(() => import('features/ManageDealer'));
const DealerReconciliationReport = lazy(() => import('features/DealerReconciliationReport'));
const ManageInvestor = lazy(() => import('features/ManageInvestor'));
const InvestorReconciliationReport = lazy(() => import('features/InvestorReconciliationReport'));
const ManageLandowner = lazy(() => import('features/ManageLandowner'));
const LandownerReconciliationReport = lazy(() => import('features/LandownerReconciliationReport'));
const ChargePointDetailScreen = lazy(() => import('features/FE/screens/ChargeConnectorDetailScreen'));
const ChargePaymentQRScreen = lazy(() => import('features/FE/screens/ChargePaymentQRScreen'));
const ChargeTransactionDetailScreen = lazy(() => import('features/FE/screens/ChargeTransactionDetailScreen'));
const InvestorGroupListScreen = lazy(() => import('features/ManageGroup/screens/InvestorGroupListScreen'));
const InvestorGroupDetailScreen = lazy(() => import('features/ManageGroup/screens/InvestorGroupDetailScreen'));
const InvestorGroupPackListScreen = lazy(() => import('features/ManageGroup/screens/InvestorGroupPackListScreen'));
const LandownerDetailScreen = lazy(() => import('features/ManageLandowner/screens/LandownerDetailScreen'));
const InvestorGroupReconciliationReport = lazy(() => import('features/InvestorGroupReconciliationReport'));
const AgencySaleAddOrderScreen = lazy(() => import('features/Agency/screens/AgencySaleAddOrderScreen'));
const AgencySaleOrderListScreen = lazy(() => import('features/Agency/screens/AgencySaleOrderListScreen'));
const ManageAgencyTransaction = lazy(() => import('features/ManageAgencyTransaction'));
const ManageOrder = lazy(() => import('features/ManageOrder'));
const AgencyContractListScreen = lazy(() => import('features/Agency/screens/AgencyContractListScreen'));
const ManageSubAgencies = lazy(() => import('features/ManageSubAgencies'));
const ManageTransactionHistory = lazy(() => import('features/ManageTransactionHistory'));
const InvestorGroupTransationListScreen = lazy(() => import('features/ManageGroup/screens/InvestorGroupTransationListScreen'));
const InvestorGroupPackageListScreen = lazy(() => import('features/ManageGroup/screens/InvestorGroupPackageListScreen'));
const InvestorGroupPackHistory = lazy(() => import('features/InvestorGroupPackHistory'));
const ElectricityPaymentHistory = lazy(() => import('features/ElectricityPaymentHistory'));
const ManageCommissionTransaction = lazy(() => import('features/ManageCommissionTransaction'));
const AgencyReconciliationListScreen = lazy(() => import('features/Agency/screens/AgencyReconciliationListScreen'));
const AgencyConfigCommissionScreen = lazy(() => import('features/Agency/screens/AgencyConfigCommissionScreen'));
const ManageGroup = lazy(() => import('features/ManageGroup'));
const ChargeStation = lazy(() => import('features/Charge/ChargeStation'));
const ChargeBrand = lazy(() => import('features/Charge/ChargeBrand'));
const ChargeTransaction = lazy(() => import('features/Charge/ChargeTransaction'));
const VehicleBrand = lazy(() => import('features/Charge/ChargeVehicleBrand'));
const ChargeVehicle = lazy(() => import('features/Charge/ChargeVehicle'));
const ChargeRfid = lazy(() => import('features/Charge/ChargeRFID'));
const ChargeDriver = lazy(() => import('features/Charge/ChargeDriver'));
const ChargePricing = lazy(() => import('features/Charge/ChargePricing'));
const ChargeSystemLog = lazy(() => import('features/Charge/ChargeSystemLog'));
const ChargeDriverTopUpHistoryScreen = lazy(() => import('features/Charge/ChargeDriver/screens/ChargeDriverTopUpHistoryScreen'));
const ChargeDashboard = lazy(() => import('features/Charge/ChargeDashboard'));
const ChargeStationMapScreen = lazy(() => import('features/Charge/ChargeStation/screens/ChargeStationMapScreen'));
const ChargeStationIframeMapScreen = lazy(() => import('features/Charge/ChargeStation/screens/ChargeStationIframeMapScreen'));
const Staff = lazy(() => import('features/System/Staff'));
const AgencyDashboard = lazy(() => import('features/Agency/screens/AgencyDashboard'));
const PoaContractListScreen = lazy(() => import('features/System/Contract/screens/PoaContractListScreen'));
const ChargeSOC = lazy(() => import('features/Charge/ChargeSOC'));
const Account = lazy(() => import('features/Account'));
const PermissionGroup = lazy(() => import('features/System/PermissionGroup'));
const PushNotification = lazy(() => import('features/System/PushNotification'));
const EnergyBill = lazy(() => import('features/Charge/ChargeEnergyBill'));
const AgencyWithdrawScreen = lazy(() => import('features/Agency/screens/AgencyWithdrawScreen'));
const SaleReconciliationReport = lazy(() => import('features/ReconciliationReport/SaleReconciliationReport'));
const AgencySaleDetailScreen = lazy(() => import('features/Agency/screens/AgencySaleDetailScreen'));
const ReconciliationReport = lazy(() => import('features/ReconciliationReport'));
const GroupReconciliationReport = lazy(() => import('features/ReconciliationReport/GroupReconciliationReport'));
const ManagePremises = lazy(() => import('features/ManagePremises'));
const ChargeMaintain = lazy(() => import('features/Charge/ChargeMaintain'));
const ChargeInstallation = lazy(() => import('features/Charge/ChargeInstallation'));
const Tutorial = lazy(() => import('features/System/InstructionConfig'));
const GeneralSetting = lazy(() => import('features/System/GeneralSetting/screens'));
const AgencyPremiseOrderListScreen = lazy(() => import('features/Agency/screens/AgencyPremiseOrderListScreen'));
const ChargePoint = lazy(() => import('features/Charge/ChargePoint'));
const ChargeInventory = lazy(() => import('features/Charge/ChargeInventory'));
const ChargeBattery = lazy(() => import('features/Charge/ChargeBattery'));
const PackageRentChangeBattery = lazy(() => import('features/PackageRentChangeBattery'));
const PackageRentCar = lazy(() => import('features/PackageRentCar'));
const BatteryRentalOrder = lazy(() => import('features/BatteryRentalOrder'));
const CarRentalOrder = lazy(() => import('features/CarRentalOrder'));
const ManageChargePointPartner = lazy(() => import('features/ManageChargePointPartner'));
const LandlordReconciliationReport = lazy(() => import('features/ReconciliationReport/LandlordReconciliationReport'));
const ChargeDriverTopupDetailScreen = lazy(() => import('features/FE/screens/ChargeDriverTopupDetailScreen'));
const DialogTopupCompletedScreen = lazy(() => import('features/FE/screens/DialogTopupCompletedScreen'));
const ActionLog = lazy(() => import('features/System/ActionLog'));
const MaintainerAuth = lazy(() => import('features/Maintainer/MaintainerAuth'));
const MaintainerDashboard = lazy(() => import('features/Maintainer/MaintainerDashboard'));
const MaintainerReconciliationReport = lazy(() => import('features/Maintainer/MaintainerReconciliationReport'));
const MaintainerChargeStation = lazy(() => import('features/Maintainer/MaintainerChargeStation'));
const MaintainerChargePoint = lazy(() => import('features/Maintainer/MaintainerChargePoint'));
const MaintainerInfo = lazy(() => import('features/Maintainer/MaintainerInfo'));
const MaintainerTicket = lazy(() => import('features/Maintainer/MaintainerTicket'));

// Load BS
require('bootstrap/dist/js/bootstrap.min');
// Load KT plugins
require('assets/plugins/ktutil');
require('assets/plugins/ktmenu');
require('assets/plugins/ktoffcanvas');
require('assets/plugins/ktcookie');
require('assets/plugins/kttoggle');
// aside
require('assets/plugins/aside/aside');
require('assets/plugins/aside/aside-menu');
require('assets/plugins/aside/aside-toggle');
// header
require('assets/plugins/header/ktheader-mobile');
require('assets/plugins/header/ktheader-topbar');

window.$ = window.jQuery = require('jquery');
window.moment = require('moment');

function App() {
  return (
    <>
      {/* Router */}
      <BrowserRouter>
        {/* Suspense */}
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <DashboardRoute />
                </PrivateRoute>
              }
            />
            {/* auth */}
            <Route
              path={`${AppRoute.auth}/*`}
              element={
                <GuestRoute>
                  <Auth />
                </GuestRoute>
              }
            />

            {/* activate account */}
            <Route
              path={`${AppRoute.mobileApp}/*`}
              element={
                <GuestRoute>
                  <Account />
                </GuestRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyApp}/*`}
              element={
                <GuestRoute>
                  <Account />
                </GuestRoute>
              }
            />

            {/* sac khong can tai khoan */}
            <Route path={`/prepaid/qr/:chargeConnectorSerial`} element={<ChargePointDetailScreen />} />
            <Route
              path="/prepaid/qr/payment"
              element={
                <GuestPaymentRoute>
                  <ChargePaymentQRScreen />
                </GuestPaymentRoute>
              }
            />
            <Route
              path="/prepaid/qr/transaction/:chargeTransactionId"
              element={
                <GuestPaymentRoute>
                  <ChargeTransactionDetailScreen />
                </GuestPaymentRoute>
              }
            />
            <Route
              path={`${AppRoute.dashboard}/*`}
              element={
                <PrivateRoute>
                  <AdminDashboardRoute>
                    <ChargeDashboard />
                  </AdminDashboardRoute>
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.agencyDashboard}/*`}
              element={
                <PrivateRoute>
                  <AgencyDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.stationList}/*`}
              element={
                <PrivateRoute>
                  <ChargeStation />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.pointList}/*`}
              element={
                <PrivateRoute>
                  <ChargePoint />
                </PrivateRoute>
              }
            />
            {/* ban do tram sac */}
            <Route path={`${AppRoute.stationsMap}/*`} element={<ChargeStationMapScreen />} />
            <Route
              path={`${AppRoute.stationsMapIframe}/*`}
              element={<ChargeStationIframeMapScreen />}
            />

            {/* hoa don tien dien */}
            <Route path={`${AppRoute.energyBillList}/*`} element={<EnergyBill />} />

            {/* hoa don mat bang */}
            <Route path={`${AppRoute.premisesList}/*`} element={<ManagePremises />} />

            {/* bao tri tru sac */}
            <Route path={`${AppRoute.chargeMaintain}/*`} element={<ChargeMaintain />} />

            {/* lap dat tru sac */}
            <Route path={`${AppRoute.chargeInstallation}/*`} element={<ChargeInstallation />} />

            {/* quan ly phien sac */}
            <Route path={`${AppRoute.listSessionPin}/*`} element={<ChargeTransaction />} />
            {/* cau hinh thong bao gui */}
            <Route path={`${AppRoute.pushNotificationList}/*`} element={<PushNotification />} />
            <Route path={`${AppRoute.systemLogList}/*`} element={<ChargeSystemLog />} />
            <Route path={`${AppRoute.inventoryList}/*`} element={<ChargeInventory />} />
            <Route path={`${AppRoute.batteryList}/*`} element={<ChargeBattery />} />
            <Route
              path={`${AppRoute.packageRentAChangeBattery}/*`}
              element={<PackageRentChangeBattery />}
            />
            <Route path={`${AppRoute.packageRentCar}/*`} element={<PackageRentCar />} />
            {/* Đơn hàng thuê pin */}
            <Route path={`${AppRoute.oderRentPin}/*`} element={<BatteryRentalOrder />} />
            {/* Đơn hàng thuê xe */}
            <Route path={`${AppRoute.oderRentCar}/*`} element={<CarRentalOrder />} />
            <Route path={`${AppRoute.valuationList}/*`} element={<ChargePricing />} />
            <Route path={`${AppRoute.staffList}/*`} element={<Staff />} />
            <Route path={`${AppRoute.tutorialList}/*`} element={<Tutorial />} />
            <Route path={`${AppRoute.generalSetting}/*`} element={<GeneralSetting />} />
            <Route path={`${AppRoute.actionLogList}/*`} element={<ActionLog />} />
            {/* quan ly nhom quyen */}
            <Route
              path={`${AppRoute.staffPermissionList}/*`}
              element={<PermissionGroup />}
            />
            {/* quan ly nhom quyen sale */}
            <Route
              path={`${AppRoute.groupPermissionAgency}/*`}
              element={
                <PermissionGroup
                  role={ChargeConstants.UserRole.AGENCY}
                  subRole={AgencyConstants.AgencyRole.SALE}
                />
              }
            />
            {/* quan ly nhom quyen doi tac */}
            <Route
              path={`${AppRoute.partnerPermissionList}/*`}
              element={
                <PermissionGroup
                  role={ChargeConstants.UserRole.AGENCY}
                  subRole={[
                    AgencyConstants.AgencyRole.GROUP,
                    AgencyConstants.AgencyRole.INVESTOR,
                    AgencyConstants.AgencyRole.LANDLORD,
                  ].join(',')}
                />
              }
            />
            {/* quan ly nhom quyen nha dau tu nhuong quyen*/}
            <Route
              path={`${AppRoute.manageGroupPermissionInvestor}/*`}
              element={<PermissionGroup />}
            />
            {/* quan ly nhom quyen nha dau tu HTKD*/}
            <Route
              path={`${AppRoute.manageGroupPermissionInvestorGroup}/*`}
              element={<PermissionGroup />}
            />
            {/* quan ly nhom quyen chu dat*/}
            <Route
              path={`${AppRoute.manageGroupPermissionLandlord}/*`}
              element={<PermissionGroup />}
            />
            {/* quan ly giao dich thanh toan */}
            <Route
              path={`${AppRoute.managePaymentTransactions}/*`}
              element={<ManagePaymentTransactions />}
            />
            {/* quan ly giao dich nap tien */}
            <Route
              path={`${AppRoute.transactionCustomerDeposit}/*`}
              element={<ChargeDriverTopUpHistoryScreen />}
            />
            {/* chi tra hoa hong */}
            <Route
              path={`${AppRoute.commissionTransactionList}/*`}
              element={<ManageCommissionTransaction />}
            />
            {/* quan ly giao dich dai ly */}
            <Route
              path={`${AppRoute.withdrawTransactionList}/*`}
              element={<ManageAgencyTransaction />}
            />
            {/* quan ly dai ly */}
            <Route path={`${AppRoute.listAgency}/*`} element={<ManageDealer />} />
            <Route path={`${AppRoute.saleInfo}/*`} element={<ManageDealer isSaleInfo={true} />} />
            <Route path={`${AppRoute.subSaleList}/*`} element={<ManageSubAgencies role="SALE" />} />
            <Route
              path={`${AppRoute.transactionHistory}/*`}
              element={<ManageTransactionHistory />}
            />
            <Route path={`${AppRoute.saleHistory}/*`} element={<ManageDealer />} />
            <Route path={`${AppRoute.agencyAddOrder}`} element={<AgencySaleAddOrderScreen />} />
            <Route
              path={`${AppRoute.agencyAddOrder}/:saleId`}
              element={<AgencySaleDetailScreen showSidebar={true} />}
            />
            <Route path={`${AppRoute.orderList}/*`} element={<ManageOrder />} />
            <Route path={`${AppRoute.agencyOrderList}/*`} element={<ManageOrder />} />
            <Route path={`${AppRoute.purchaseOrder}/*`} element={<ManageOrder />} />
            <Route path={`${AppRoute.saleOrder}/*`} element={<ManageOrder />} />
            <Route path={`${AppRoute.listCustomer}/*`} element={<ChargeDriver />} />
            {/* quan ly nha dau tu */}
            <Route path={`${AppRoute.manageInvestor}/*`} element={<ManageInvestor />} />
            <Route path={`${AppRoute.listNDTNQ}/*`} element={<ManageInvestor />} />
            <Route
              path={`${AppRoute.groupList}/add-order`}
              element={<AgencySaleAddOrderScreen removeBaseLayout={false} />}
            />
            <Route path={`${AppRoute.listInvestorHTKD}/*`} element={<ManageGroup />} />
            <Route
              path={`${AppRoute.groupsList}/add-order`}
              element={<AgencySaleAddOrderScreen />}
            />
            <Route path={`${AppRoute.groupInfo}/*`} element={<ManageGroup isGroupInfo={true} />} />
            <Route
              path={`${AppRoute.subGroupList}/*`}
              element={<ManageSubAgencies role="GROUP" />}
            />

            <Route
              path={`${AppRoute.investorsReport}/*`}
              element={<InvestorReconciliationReport />}
            />
            <Route
              path={`${AppRoute.groupsReport}/*`}
              element={<InvestorGroupReconciliationReport />}
            />
            <Route
              path={`${AppRoute.reportReconciliationNDTHTKD}/*`}
              element={<GroupReconciliationReport />}
            />
            <Route
              path={`${AppRoute.investorInfo}/*`}
              element={<ManageInvestor isInvestorInfo={true} />}
            />
            <Route
              path={`${AppRoute.listPackageInvestorHTKD}/*`}
              element={<InvestorGroupPackListScreen />}
            />
            <Route path={`${AppRoute.groupPackHistory}/*`} element={<InvestorGroupPackHistory />} />
            {/* quan ly chu dat */}
            <Route path={`${AppRoute.landlordList}/*`} element={<ManageLandowner />} />
            <Route path={`${AppRoute.landlordInfo}/*`} element={<ManageLandowner isLandlordInfo={true} />} />
            <Route
              path={`${AppRoute.electricityPayment}/*`}
              element={<ElectricityPaymentHistory />}
            />
            <Route
              path={`${AppRoute.landlordsReport}/*`}
              element={<LandownerReconciliationReport />}
            />
            <Route
              path={`${AppRoute.landlordReport}/*`}
              element={<LandlordReconciliationReport />}
            />
            {/* quan ly doi tac mua tru sac */}
            <Route path={`${AppRoute.chargePointPartnerList}/*`} element={<ManageChargePointPartner />} />

            <Route path={`${AppRoute.manageVehicleBrand}/*`} element={<VehicleBrand />} />
            <Route path={`${AppRoute.vehicleList}/*`} element={<ChargeVehicle mode="customer" />} />
            <Route path={`${AppRoute.operatorVehicleList}/*`} element={<ChargeVehicle mode="operator" />} />
            <Route path={`${AppRoute.rfidList}/*`} element={<ChargeRfid />} />
            <Route path={`${AppRoute.manageChargeBrand}/*`} element={<ChargeBrand />} />
            <Route path={`${AppRoute.superDashboard}/*`} element={<ChargeSOC />} />
            {/* quybka */}
            {/* agency sale add order */}
            <Route path={`${AppRoute.agencySaleAddOrder}`} element={<AgencySaleAddOrderScreen />} />
            <Route
              path={`${AppRoute.agencySaleAddOrder}/:saleId`}
              element={<AgencySaleAddOrderScreen />}
            />
            <Route
              path={`${AppRoute.agencySaleOrderList}/*`}
              element={<AgencySaleOrderListScreen />}
            />
            <Route
              path={`${AppRoute.agencySaleOrderDetail}/:saleId`}
              element={<AgencySaleDetailScreen showSidebar={true} />}
            />
            <Route
              path={`${AppRoute.premiseOrderList}/*`}
              element={<AgencyPremiseOrderListScreen />}
            />
            <Route
              path={`${AppRoute.agencyContractList}/*`}
              element={<AgencyContractListScreen />}
            />
            {/* ds bao cao doi soat */}
            <Route
              path={`${AppRoute.agencyReconciliationList}`}
              element={<AgencyReconciliationListScreen />}
            />
            {/* cau hinh hoa hong */}
            <Route
              path={`${AppRoute.agencyConfigCommission}/*`}
              element={<AgencyConfigCommissionScreen />}
            />
            {/* hoa don tien dien */}
            <Route path={`${AppRoute.energyBillList}/*`} element={<EnergyBill />} />
            {/* danh sach hop dong */}
            <Route path={`${AppRoute.contractList}/*`} element={<AgencyContractListScreen />} />
            <Route path={`${AppRoute.poaContract}`} element={<PoaContractListScreen />} />
            <Route path={`${AppRoute.withdrawTransaction}/*`} element={<AgencyWithdrawScreen />} />
            {/* bao cao doi soat */}
            <Route path={`${AppRoute.reconciliationReport}/*`} element={<ReconciliationReport />} />
            {/* nap tien qua ma qr */}
            <Route path={`/topup/:serialNumber`} element={<ChargeDriverTopupDetailScreen />} />
            <Route
              path="/topup/:serialNumber/payment"
              element={
                <GuestPaymentRoute>
                  <ChargePaymentQRScreen />
                </GuestPaymentRoute>
              }
            />
            <Route path={`/payment/vnpay/completed`} element={<DialogTopupCompletedScreen />} />

            {/* ---- MAINTAINER ---- */}
            {/* Maintainer auth */}
            <Route
              path={`${AppRoute.maintainerAuth}/*`}
              element={
                <GuestRoute>
                  <MaintainerAuth />
                </GuestRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerApp}/*`}
              element={
                <GuestRoute>
                  <Account />
                </GuestRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerDashboard}/*`}
              element={
                <PrivateRoute>
                  <MaintainerDashboard />
                </PrivateRoute>
              }
            />
            <Route path={`${AppRoute.maintainerList}/*`} element={<MaintainerInfo />} />
            <Route path={`${AppRoute.maintainerInfo}/*`} element={<MaintainerInfo isMaintainerInfo={true} />} />
            <Route
              path={`${AppRoute.maintainerReport}/*`}
              element={<MaintainerReconciliationReport />}
            />
            <Route path={`${AppRoute.ticketList}/*`} element={<MaintainerTicket />} />
            <Route path={`${AppRoute.myTicket}/*`} element={<MaintainerTicket isMine={true} />} />
            <Route
              path={`${AppRoute.maintainerStationList}/*`}
              element={
                <PrivateRoute>
                  <MaintainerChargeStation />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerPointList}/*`}
              element={
                <PrivateRoute>
                  <MaintainerChargePoint />
                </PrivateRoute>
              }
            />
            <Route path={`${AppRoute.maintainerStationsMap}/*`} element={<ChargeStationMapScreen />} />
            <Route path="*" element={<KTPageError01 />} />
          </Routes>
        </Suspense>
      </BrowserRouter>

      {/* App Dialog */}
      <AppDialog />
      <AppDialogCustom />
      {/* Toast */}
      <AppToast />
      {/* Listener */}
      <DataCommonListener />

      {/* eKYC div */}
      <div id="eKYC_div"></div>
    </>
  );
}

export default App;
